import { useEffect, useState } from "react";

import EditModuleForm from "../../components/editModuleForm/EditModuleForm";
import { useUserData, useUserRoleData } from "../account/Account";

const EditModule = () => {

    const { userRoleData } = useUserRoleData();
    const userRoleName = userRoleData?.title;
    const { userData } = useUserData();
    const userCustomerId = userData?.customerId

    useEffect(() => {
        if (userRoleName && userRoleName !== '') {
          if (userRoleName !== 'Admin') {
            window.location.assign('/');
          }
        }
      }, [userRoleName]);

    return (
        <>
            <EditModuleForm
                userCustomerId={userCustomerId}
            />
        </>
    )
}

export default EditModule;